export function formatWeekTitleDate (date) {
  let start      = date.start,
      end        = date.end,
      startYear  = start.year,
      startMonth = start.month + 1,
      startDay   = start.day + '. ',
      endYear    = end.year,
      endMonth   = end.month + 1,
      endDay     = end.day + '. '

  if (startYear === endYear) {
    startYear = ''
  }

  if (startMonth === endMonth) {
    startMonth = ''
  }
  else {
    startMonth = startMonth + '. '
  }

  return startDay + startMonth + startYear + ' - ' + endDay + endMonth + '. ' +
    endYear
}
